export const NOTIFICATION_POLLING_RATE = 5000;